import AttenderInput from '@/components/Record/SubjectContent/AttenderInput';
import AttenderItem from '@/components/Record/SubjectContent/AttenderItem';
import SearchList from '@/components/Record/SubjectContent/SearchList';
import React, { forwardRef } from 'react';
import { InputContainer } from './styles';
import { InternalParticipant, RecordFilter } from '@/types/api';
import { useTranslation } from 'react-i18next';
import { Path } from 'react-hook-form';

interface ShareSearchInputSectionProps {
  isFocus: boolean;
  registerName: Path<RecordFilter>;
  shareAttender: InternalParticipant[];
  attenderFocusIndex: number;
  handleDelete: (passportId: string) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  setIsFocus: (value: boolean) => void;
  debouncedValue: string;
  searchData: InternalParticipant[];
  disableData?: any;
  searchFocusIndex: number;
  handleTogglePassport: (passport: InternalParticipant) => void;
  rightChildren?: React.ReactNode;
}

const ShareSearchInputSection = forwardRef<
  HTMLDivElement,
  ShareSearchInputSectionProps
>(
  (
    {
      isFocus,
      registerName,
      shareAttender,
      attenderFocusIndex,
      handleDelete,
      handleKeyDown,
      setIsFocus,
      debouncedValue,
      searchData,
      disableData,
      searchFocusIndex,
      handleTogglePassport,
      rightChildren,
    },
    ref,
  ) => {
    const { t } = useTranslation();

    return (
      <InputContainer ref={ref}>
        <AttenderInput
          isFocus={isFocus}
          registerName={registerName}
          placeholder={t('이 문서를 공유할 임직원 혹은 부서를 검색해 주세요')}
          leftChildren={shareAttender.map((item, index) => (
            <AttenderItem
              key={`passport-${item.passportId}`}
              data={{
                passportId: item.passportId,
                name: item.name,
                departmentName: item.departmentName,
                positionName: item.positionName,
                divisionName: item.divisionName,
                profileImageUrl: item.profileImageUrl,
              }}
              handleDelete={handleDelete}
              isFocused={attenderFocusIndex === index}
            />
          ))}
          rightChildren={rightChildren}
          handleKeyDown={handleKeyDown}
          onFocus={() => setIsFocus(true)}
          autoFocus={false}
          style={{
            maxHeight: '212px',
            overflowY: 'scroll',
          }}
        />
        {isFocus && (
          <SearchList
            registerKey={'shareAttender' as const}
            open={debouncedValue.length > 0}
            data={searchData}
            disableData={disableData}
            focusIndex={searchFocusIndex}
            onToggle={handleTogglePassport}
            searchKeyword={debouncedValue}
          />
        )}
      </InputContainer>
    );
  },
);

ShareSearchInputSection.displayName = 'ShareSearchInputSection';

export default ShareSearchInputSection;
